import { API_RESPONSE_STATUS } from "../../utils/global_variables";
import {
    GET_PROFIT_LOSS_DATA_FAILURE, GET_PROFIT_LOSS_DATA_SUCCESS, GET_PUT_CALL_MASTER_DATA_FAILURE, GET_PUT_CALL_MASTER_DATA_SUCCESS, GET_SHARE_HOLDING_PATTERN_DATA_FAILURE,
    GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS, GET_QUARTERLY_TREND_FAILURE, GET_COMPANY_RESULT_DATA_FAILURE, GET_COMPANY_RESULT_DATA_SUCCESS
    , GET_QUARTERLY_TREND_SUCCESS, GET_COMPANY_BALANCE_SHEET_DATA_FAILURE, GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS, GET_KEYSTATS,
    GET_DELIVERY_QUANTITY, GET_CONTRACT_DETAILS, GET_CONTRACT_CODE_INFO, GET_GSM_CATEGORY, GET_COMPANY_BACKGROUND_DATA,
    GET_COMPANY_EXCHANGE_DATA, GET_RECORD_DATA, GET_LISTING_INFO, GET_MANAGEMENT_DETAILS, GET_SECURITY_DETAILS,
    GET_CODE_INFO, GET_COMPANY_HISTORY, GET_SCRIPOVERVIEW_MARKET_PULSE_SUCCESS, UPDATE_MARKET_DEPTH,
    GET_SIMPLE_MOVING_AVERAGES, GET_FUTURE_TAB_DATA_SUCCESS, GET_FUTURE_TAB_DATA_FAILURE, GET_HEALTH_SCORE_FAILURE, GET_HEALTH_SCORE_SUCCESS, RESET_MARKET_OVERVIEW, SET_SCRIP_OVERVIEW_DATA, GET_MARKET_MOVEMENT_FAILURE, GET_MARKET_MOVEMENT_SUCCESS, INDICES, GET_PEER_COMPARISON_FAILURE, GET_PEER_COMPARISON_SUCCESS, GET_OI_DATA_FOR_SCRIP_FAILURE_1, GET_OI_DATA_FOR_SCRIP_SUCCESS_1,
    GET_OI_DATA_FOR_SCRIP_FAILURE_2, GET_OI_DATA_FOR_SCRIP_FAILURE_3, GET_OI_DATA_FOR_SCRIP_SUCCESS_2, GET_OI_DATA_FOR_SCRIP_SUCCESS_3, GET_CONTRACT_MARGIN_DETAILS, GET_PARTS_OF_INDICES, GET_HEALTH_PARAM_SCORE_SUCCESS, GET_HEALTH_PARAM_SCORE_FAILURE, OVER_VIEW_CARD, GET_SCRIP_MARKET_PULSE_SUCCESS, SET_AVAILABLE_EXCHANGES, RESET_COMPANY_CONTRACT_INFO, SET_COMMON_COMPANY_CONTRACT_INFO, UPDATE_CONSTITUENT_VIEW, GET_HEALTH_PARAM_VALUE_SUCCESS, GET_HEALTH_PARAM_VALUE_FAILURE, GET_FINANCIAL_RATIO_DATA,
    SET_ARR_ROW_DATA,
    GET_FUTURES_COLUMNS_LIST,
    GET_CONSTITUENTS_COLUMNS_LIST,
    EXPAND_SIDE_CHART,
    SIDE_OVERVIEW_WATCHLIST_SYNC,
} from "../actionTypes";

const initialState = {
    marketPulse: null,
    marketDepth: [],
    simpleMovingAverages: [],
    keystats: [],
    arrFutureTabData: null,
    objCompanyHistory: [],
    objCodeInfo: [],
    securityDetails: [],
    objContractDetails: {},
    listing: {},
    recordData: [],
    gsmCategory: [],
    arrExchangeData: [],
    objCompanyBackgroundData: [],
    arrDirectorData: [],
    constituentsData: [],
    quarterlyTrend: [],
    shareHoldingPatternData: [],
    companyResultData: [],
    profitLossData: [],
    companyBalanceSheetData: [],
    OIDataForScrip1: [],
    putCallMasterData: [],
    arrDeliveryQuantity: [],
    healthScore: [],
    peerComparison: [],
    OIDataForScrip2: [],
    OIDataForScrip3: [],
    marketMovementInfo: [],
    scripOverviewData: {},
    selectedArrRowData: [],
    arrPartsOfIndices: [],
    objContractMarginDetails: {},
    arrHealthParamScore: null,
    overviewActiveTab: '',
    arrScripInfoMarketPulse: null,
    arrKeystatsFinancialRatio: [],
    // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- Start
    availableExchanges: [],
    arrHealthParamValues: [],
    // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- End
    objConstituentsIndexes: {},// Azeem K -05-07-2024 : Constituents Optimization
    constituentView: '',
    constituentAPIStatus: API_RESPONSE_STATUS.PENDING,
    futureColdef: [],
    constituentsColdef: [],
    isSideExpanded: false,
    isSideOverViewSynced: false
};

const marketOverviewReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SIDE_OVERVIEW_WATCHLIST_SYNC:
            return {
                ...state,
                isSideOverViewSynced: actions.payload
            };
        case EXPAND_SIDE_CHART:
            return {
                ...state,
                isSideExpanded: actions.payload
            };
        // Azeem K -05-07-2024 : Constituents Optimization --Start
        case UPDATE_CONSTITUENT_VIEW: {
            return {
                ...state,
                constituentView: actions?.payload
            };
        }
        // Azeem K -05-07-2024 : Constituents Optimization --End

        case OVER_VIEW_CARD?.UPDATE_OVERVIEW_ACTIVE_TAB:
            return {
                ...state,
                overviewActiveTab: actions?.payload
            };
        case GET_MARKET_MOVEMENT_SUCCESS:
            return {
                ...state,
                marketMovementInfo: actions.payload

            };
        case GET_MARKET_MOVEMENT_FAILURE:
            return {
                ...state,
                marketMovementInfo: actions.payload

            };
        case GET_KEYSTATS:
            return {
                ...state,
                keystats: actions.payload

            };



        case GET_SIMPLE_MOVING_AVERAGES:
            return {
                ...state,
                simpleMovingAverages: actions.payload

            };

        case GET_DELIVERY_QUANTITY:
            return {
                ...state,
                arrDeliveryQuantity: actions.payload
            };


        case UPDATE_MARKET_DEPTH: {
            return {
                ...state,
                marketDepth: [...actions.payload]
            };
        }
        case GET_SCRIPOVERVIEW_MARKET_PULSE_SUCCESS:
            return {
                ...state,
                marketPulse: actions.payload

            };

        case GET_MANAGEMENT_DETAILS:
            return {
                ...state,
                arrDirectorData: actions.payload


            };
        case GET_COMPANY_HISTORY:
            return {
                ...state,
                objCompanyHistory: actions.payload
            };
        case GET_CODE_INFO:
            return {
                ...state,
                objCodeInfo: actions.payload

            };
        case GET_SECURITY_DETAILS:
            return {
                ...state,
                securityDetails: actions.payload

            };
        case GET_CONTRACT_CODE_INFO:
            return {
                ...state,
                objContractCodeInfo: actions.payload

            };
        case GET_CONTRACT_DETAILS:
            return {
                ...state,
                objContractDetails: actions.payload

            };

        case GET_CONTRACT_MARGIN_DETAILS:
            return {
                ...state,
                objContractMarginDetails: actions.payload

            };


        case GET_LISTING_INFO:
            return {
                ...state,
                listing: actions.payload
            };
        case GET_PARTS_OF_INDICES:
            return {
                ...state,
                arrPartsOfIndices: actions.payload
            };

        case GET_RECORD_DATA:
            return {
                ...state,
                recordData: actions.payload

            };

        case GET_GSM_CATEGORY:
            return {
                ...state,
                gsmCategory: actions.payload

            };

        case GET_COMPANY_EXCHANGE_DATA:
            return {
                ...state,
                arrExchangeData: actions.payload

            };

        case GET_COMPANY_BACKGROUND_DATA:
            return {
                ...state,
                objCompanyBackgroundData: actions.payload

            };


        //AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - Start
        case GET_FUTURE_TAB_DATA_SUCCESS:
            return {
                ...state,
                arrFutureTabData: actions.payload
            };
        case GET_FUTURE_TAB_DATA_FAILURE:
            return {
                ...state,
                arrFutureTabData: actions.payload
            };
        case GET_COMPANY_BALANCE_SHEET_DATA_FAILURE:
            return {
                ...state,
                companyBalanceSheetData: actions.payload
            };
        case GET_COMPANY_BALANCE_SHEET_DATA_SUCCESS:
            return {
                ...state,
                companyBalanceSheetData: actions.payload
            };
        case GET_QUARTERLY_TREND_FAILURE:
            return {
                ...state,
                quarterlyTrend: actions.payload
            };
        case GET_QUARTERLY_TREND_SUCCESS:
            return {
                ...state,
                quarterlyTrend: actions.payload
            };
        case GET_SHARE_HOLDING_PATTERN_DATA_FAILURE:
            return {
                ...state,
                shareHoldingPatternData: actions.payload
            };
        case GET_SHARE_HOLDING_PATTERN_DATA_SUCCESS:
            return {
                ...state,
                shareHoldingPatternData: actions.payload
            };
        case GET_COMPANY_RESULT_DATA_FAILURE:
            return {
                ...state,
                companyResultData: actions.payload
            };
        case GET_COMPANY_RESULT_DATA_SUCCESS:
            return {
                ...state,
                companyResultData: actions.payload
            };
        case GET_PROFIT_LOSS_DATA_FAILURE:
            return {
                ...state,
                profitLossData: actions.payload
            };
        case GET_PROFIT_LOSS_DATA_SUCCESS:
            return {
                ...state,
                profitLossData: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_FAILURE_1:
            return {
                ...state,
                OIDataForScrip1: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_SUCCESS_1:
            return {
                ...state,
                OIDataForScrip1: actions.payload
            };
        case GET_PUT_CALL_MASTER_DATA_FAILURE:
            return {
                ...state,
                putCallMasterData: actions.payload
            };
        case GET_PUT_CALL_MASTER_DATA_SUCCESS:
            return {
                ...state,
                putCallMasterData: actions.payload
            };
        case GET_HEALTH_SCORE_FAILURE:
            return {
                ...state,
                healthScore: actions.payload
            };
        case GET_HEALTH_SCORE_SUCCESS:
            return {
                ...state,
                healthScore: actions.payload
            };
        case GET_PEER_COMPARISON_FAILURE:
            return {
                ...state,
                peerComparison: actions.payload
            };
        case GET_PEER_COMPARISON_SUCCESS:
            return {
                ...state,
                peerComparison: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_SUCCESS_2:
            return {
                ...state,
                OIDataForScrip2: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_FAILURE_2:
            return {
                ...state,
                OIDataForScrip2: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_FAILURE_3:
            return {
                ...state,
                OIDataForScrip3: actions.payload
            };
        case GET_OI_DATA_FOR_SCRIP_SUCCESS_3:
            return {
                ...state,
                OIDataForScrip3: actions.payload
            };
        case SET_SCRIP_OVERVIEW_DATA: {
            return {
                ...state,
                scripOverviewData: actions.payload
            };
        }
        case SET_ARR_ROW_DATA:
            return {
                ...state,
                selectedArrRowData: actions?.payload
            };
        case GET_FINANCIAL_RATIO_DATA: {
            return {
                ...state,
                arrKeystatsFinancialRatio: actions.payload
            };
        }

        // Vinit R - 03-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        case RESET_MARKET_OVERVIEW:
            return {
                ...initialState,
            };

        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        case RESET_COMPANY_CONTRACT_INFO:
            // const gsmCategory = [...state?.gsmCategory];
            const arrExchangeData = state?.arrExchangeData?.length > 0 ? [...state?.arrExchangeData] : [];
            const availableExchanges = state?.availableExchanges?.length > 0 ? [...state?.availableExchanges] : [];
            const objCompanyBackgroundData = Object.keys(state?.objCompanyBackgroundData)?.length > 0 ? { ...state?.objCompanyBackgroundData } : {};
            const listing = Object.keys(state?.listing)?.length > 0 ? { ...state?.listing } : {};
            const arrDirectorData = state?.arrDirectorData?.length > 0 ? [...state?.arrDirectorData] : [];
            const objCompanyHistory = state?.objCompanyHistory?.length > 0 ? [...state?.objCompanyHistory] : [];

            return {
                ...initialState,
                // gsmCategory,
                arrExchangeData,
                availableExchanges,
                objCompanyBackgroundData,
                listing,
                arrDirectorData,
                objCompanyHistory
            };
        // Vinit R - 08-04-2024 Company Info to be kept common irrespective of exchanges -- End

        //AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End
        case INDICES.GET_CONSTITUENTS_DATA_SUCCESS:
            return {
                ...state,
                constituentsData: actions.payload
            };
        case GET_HEALTH_PARAM_SCORE_FAILURE:
            return {
                ...state,
                arrHealthParamScore: actions.payload
            };
        case GET_HEALTH_PARAM_SCORE_SUCCESS:
            return {
                ...state,
                arrHealthParamScore: actions.payload
            };
        case GET_SCRIP_MARKET_PULSE_SUCCESS:
            return {
                ...state,
                arrScripInfoMarketPulse: actions.payload
            };

        // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        case SET_AVAILABLE_EXCHANGES:
            return {
                ...state,
                availableExchanges: actions.payload
            };

        // Vinit R - 02-04-2024 Company Info to be kept common irrespective of exchanges -- End

        // Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- Start
        case SET_COMMON_COMPANY_CONTRACT_INFO:
            return {
                ...state,
                arrDirectorData: actions.payload.boardOfDirectorResp,
                objCompanyHistory: actions.payload.companyHistoryResp,
                listing: actions.payload.companyListingInfoResp,
                objCompanyBackgroundData: actions.payload.companyBackgroundResp,
                arrExchangeData: actions.payload.companyExchangeDataResp
            };
        // Vinit R - 05-04-2024 Company Info to be kept common irrespective of exchanges -- End
        // Azeem K -05-07-2024 : Constituents Optimization --Start
        case INDICES.GET_CONSTITUENTS_INDEXES:
            return {
                ...state,
                objConstituentsIndexes: actions.payload
            };
        // Azeem K -05-07-2024 : Constituents Optimization --End
        case GET_HEALTH_PARAM_VALUE_SUCCESS:
            return {
                ...state,
                arrHealthParamValues: actions.payload
            };
        case GET_HEALTH_PARAM_VALUE_FAILURE:
            return {
                ...state,
                arrHealthParamValues: actions.payload
            };

        case UPDATE_CONSTITUENT_VIEW:
            return {
                ...state,
                constituentView: actions.payload
            };
        case INDICES.UPDATE_CONSTITUENT_VIEW_API_STATUS:
            return {
                ...state,
                constituentAPIStatus: actions.payload
            };
        case GET_FUTURES_COLUMNS_LIST:
            return {
                ...state,
                futureColdef: actions.payload
            };
        case GET_CONSTITUENTS_COLUMNS_LIST:
            return {
                ...state,
                constituentsColdef: actions.payload
            };
        default:
            return state;
    }

};

export default marketOverviewReducer;